<div class="modal-body">
    <div class="card row" style="display:block;margin-bottom:15px;">
        <div>
            <h4 style="margin-left: 10px; display: inline-block;" *ngIf="WOorSI === 'WO'">Work Order History</h4>
            <h4 style="margin-left: 10px; display: inline-block;" *ngIf="WOorSI === 'SI'">Service Items on Site</h4>
            <button type="button" class="btn btn-text-primary" (click)="closeModal()" style="float: right;margin-top: -5px;">Close</button>
        </div>
        <hr style="margin:0px;" />
        <div *ngIf="!formData.onEdit" class="col-12">
            <span style="white-space: pre-line;">{{woData.ServiceSiteNotes}}</span>
            <button type="button" class="btn btn-text-primary" (click)="editNotes()" *ngIf="smDataService.currentOnline && SMEditServiceSiteNote">Edit</button>
        </div>
        <div *ngIf="formData.onEdit" class="col-12" style="margin-top: 10px; display: flex;">
            <textarea [(ngModel)]="woData.ServiceSiteNotes" class="form-control" appElastic rows="2" placeholder="Site Notes"
                      style="font-size:14px;overflow-y: hidden;max-width:300px;"></textarea>
            <button type="button" class="btn btn-text-primary" (click)="saveNotes()" style="float:right;">Save</button>
        </div>
    </div>
    <div class="card row" style="display:block;margin-bottom:15px;" *ngIf="WOorSI === 'WO'">
        <div style="overflow-x: auto;">
            <div>
                <table class="table">
                    <thead>
                        <tr>
                            <th>WO#</th>
                            <th>Technician</th>
                            <th>Date</th>
                            <th>Notes</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let data of woHistoryList">
                            <td><a style="cursor:pointer;" [routerLink]="" class="ml-1" (click)="toDrillDown(data)">{{data.WorkOrder}}</a></td>
                            <td>{{data.TripTechnician}}</td>
                            <td>{{data.CompletedDateDisplay}}</td>
                            <td><quill-view-html [content]="data.TripNotesHTML" theme="snow" *ngIf="data.TripNotesHTML != null"></quill-view-html></td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
    <div class="card row" style="display:block;" *ngIf="WOorSI === 'SI'">
        <div style="margin-bottom:15px;">
            <div class="col-12">
                <input type="text" class="form-control" (ngModelChange)="filterServiceItem()" [(ngModel)]="formData.searchText" placeholder="search service items..." />
            </div>
        </div>

        <div>
            <table class="table">
                <thead>
                    <tr>
                        <th>Service Item</th>
                        <th>Description (Model/Serial #) Location</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let data of filteredServiceList">
                        <td><a style="cursor:pointer;" [routerLink]="" class="ml-1" (click)="routeToServiceDetail(data)">{{data.ServiceItem}}</a></td>
                        <td>
                            <div style="white-space: pre-line;" [innerHTML]="data.DescriptionHTML"></div>
                            <span *ngIf="data.Model != null && data.SerialNumber != null">({{data.Model}}/{{data.SerialNumber}}#) <span *ngIf="data.Location != null">{{data.Location}}</span></span>
                            <span *ngIf="data.Model == null && data.SerialNumber != null">({{data.SerialNumber}}#) <span *ngIf="data.Location != null">{{data.Location}}</span></span>
                            <span *ngIf="data.Model != null && data.SerialNumber == null">({{data.Model}}) <span *ngIf="data.Location != null">{{data.Location}}</span></span>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
        <div class="card-footer" style="background-color: #005f9e;" *ngIf="smDataService.currentOnline && SMAllowServiceItemEdit">
            <div class="row">
                <div class="col-12" (click)="createServiceItem()" style="text-align: center;font-weight:bold;color:white;cursor:pointer;">Add Service Item</div>
            </div>
        </div>
    </div>
</div>
<div class="modal-footer">
    <div style="width:100%;">
        <button type="button" class="btn btn-text-primary" (click)="closeModal()">Close</button>
    </div>
</div>